import { useEffect, useRef, useState, useCallback, useMemo } from 'react';

import {
    WandSparkles
} from "lucide-react";

import { useNotes } from "../contexts/NotesContext";
import { CLOUDFLARE_URL } from '@/lib/config';
import { formatInlineMarkdown } from '../lib/util';
import { useCommunication } from '@/lib/CommunicationWrapper';
//import { RestrictedButton, RestrictedButtonView, RestrictedIcon, RestrictedView, UnrestrictedButtonView } from '@/components/RestrictedButton';
import { RestrictedButton, RestrictedButtonView, RestrictedIcon, UnrestrictedButtonView } from '@/lib/restrictions';


const GenerateSmartNoteBtn = () => {


    const { noteId, setSmartNote, getSmartNoteContent, settings, transcript } = useNotes();
    const { authenticatedClient, showError, authenticatedFetch } = useCommunication();

    const generate = async () => {

        const client = await authenticatedClient();

        if (!client) {
            showError("There was an error while generating smart note", "error");
        };
        
        const res = await authenticatedFetch(`${CLOUDFLARE_URL}/notes/smart-note`, {
            method: 'POST',
            body: {
                noteId: noteId
            }
        } as any);

        if (!res.body) return;

        const reader = res.body.getReader();
        const decoder = new TextDecoder();
        let accumulatedResponse = '';

        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            // Decode the chunk and split by double newlines (SSE format)
            const chunk = decoder.decode(value);
            const lines = chunk.split('\n\n');

            for (const line of lines) {
                console.log("line", line);
                if (line.startsWith('data: ')) {
                    try {
                        const eventData = JSON.parse(line.slice(6));

                        if (eventData.type === 'delta') {
                            accumulatedResponse += eventData.delta || '';
                            setSmartNote(accumulatedResponse);
                            // Update the last message with the accumulated response
                        } else if (eventData.type === 'done') {
                            setSmartNote(eventData.text || accumulatedResponse);
                        } else if (eventData.type === 'error') {
                            console.error('Stream error:', eventData.error);
                            throw new Error(eventData.error);
                        }
                    } catch (e) {
                        console.error('Error parsing stream data:', e);
                    }
                }
            }
        }
    }

    return (
        <div className="flex flex-col items-center justify-center">
            <RestrictedButton restrictedPlans={["none", "free", "proLite"]} onClick={generate}>
                <RestrictedButtonView>
                    <button onClick={generate} className="cursor-pointer bg-theme-1 text-theme-0 hover:bg-theme-2 hover:text-theme-0 transition-all duration-300 border border-theme rounded-xl px-4 py-2">
                        <RestrictedIcon restrictedPlans={["none", "free", "proLite"]} className="size-3.5 fill-current text-theme-0">
                            <span className="text-sm">Generate smart note</span>
                        </RestrictedIcon>
                    </button>
                </RestrictedButtonView>
                <UnrestrictedButtonView>
                    <button onClick={generate} className="flex items-center gap-2 cursor-pointer bg-theme-1 text-theme-0 hover:bg-theme-2 hover:text-theme-0 transition-all duration-300 border border-theme rounded-xl px-4 py-2">
                        <WandSparkles className="size-3.5" />
                        <span className="text-sm">Generate smart note</span>
                    </button>
                </UnrestrictedButtonView>
            </RestrictedButton>
            <p className="text-sm text-theme-1 text-center mt-[5px]">Based on your notes {transcript.length > 0 ? " and transcript" : ""}</p>
        </div>
    )
}

export const SmartNoteTab = () => {


    const { noteId, smartNote, getSmartNoteContent, setSmartNote, transcript } = useNotes();
    const [loading, setLoading] = useState(false);
    const init = useRef(false);

    console.log("smartNote", smartNote, smartNote === "" || smartNote === null);

    useEffect(() => {
        if (!noteId) return;
        if (init.current === true) return;
        init.current = true;
        setLoading(true);
        getSmartNoteContent(noteId).then((smartNote: any) => {
            setSmartNote(smartNote);
            setLoading(false);
        });
    }, [noteId]);

    if (loading) {
        return (
            <div className="flex flex-col gap-[10px]">
            </div>
        )
    }

    if (!smartNote || smartNote === "") {

        return (
            <div className="flex items-center justify-center h-full w-full">
                <GenerateSmartNoteBtn />
            </div>
        )
    }

    const formatSmartNote = (smartNote: string) => {
        return smartNote.replace(/<[^>]*>?/g, '');
    }

    return (
        <div className="max-w-[640px] mx-auto w-full h-full overflow-y-auto">
            <div className="py-8" dangerouslySetInnerHTML={{ __html: formatInlineMarkdown(smartNote) }} />
            <GenerateSmartNoteBtn />
        </div>
    )
}